<template>
  <!-- Navbar -->
  <nav
    class="relative w-full z-10 bg-white border-b border-blueGray-200 md:flex-row md:flex-nowrap md:justify-start flex items-center p-4"
  >
    <div
      class="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
    >
      <!-- Brand -->
      <a
        class="text-blueGray-700 text-sm hidden lg:inline-block font-semibold"
        href="javascript:void(0)"
      >
      <i class="pi text-blueGray-900" :class="[activeMenu.icon ? activeMenu.icon: 'pi-building-columns']"></i>
      {{ activeMenu.title }} {{ dashboard().business ? ` | ${dashboard().business.name} - ${dashboard().business.code}` : '' }}
      </a>
      <!-- Form -->
      <form
        class="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3"
      >
        <div class="relative flex w-full flex-wrap items-stretch">
          <span
            class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
          >
            <i class="pi pi-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search here..."
            class="border border-blueGray-200 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-blueGray-50 rounded text-sm outline-none focus:outline-none w-full pl-10"
          />
        </div>
      </form>
      <!-- User -->
      <ul class="flex-col md:flex-row list-none items-center hidden md:flex">
        <user-dropdown />
      </ul>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    UserDropdown,
  },
  methods: {
    ...mapGetters(["dashboard"])
  },
  props: {
    activeMenu: {
      type: Object,
      required: false
    }
  }
};
</script>
